
import { Box } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { useFormContext, Controller } from "react-hook-form";
import { useTranslate } from "src/locales";
import ByzMuiSelect from "src/components/core-components/mui/ByzMuiSelect";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMuiRadioButton from "src/components/core-components/mui/buttons/ByzMuiRadioButton";
import ByzTitleAndInputBox from "src/components/core-components/ByzTitleAndInputBox/ByzTitleAndInputBox";

export const NeuromuscularSection = () => {
  const { t } = useTranslate();
  const { control } = useFormContext();

  return (
    <Box
      sx={{
        border: "1px solid #DBDBDB",
        borderRadius: "4px",
        padding: "20px",
        width: "100%",
        marginBottom: "20px",
      }}
    >
      <Grid
        sx={{
          backgroundColor: "#63B4FF33",
          color: "#2979C3",
          borderRadius: "10px",
        }}
      >
        <ByzMuiTypography isTitle paddingRight={"20px"} paddingTop={"5px"}>
          {t("child-patient-assessment.neuromuscular-features")}
        </ByzMuiTypography>
      </Grid>

      <Grid container spacing={2} pt={2}>
        <Grid md={2} xs={6}>
          <ByzTitleAndInputBox marginLeft="0px" title={t("child-patient-assessment.muscle-tone")}>
            <Controller
              name="neuromuscular.muscleTone"
              control={control}
              render={({ field }) => (
                <ByzMuiSelect
                  {...field}
                  options={[]}
                  label={t("open-process-menu.select", "capitalize")}
                  sx={{ pt: 1 }}
                />
              )}
            />
          </ByzTitleAndInputBox>
        </Grid>

        {[
          { name: "neuromuscular.moroReflex", label: "child-patient-assessment.moro-reflex" },
          { name: "neuromuscular.suckingReflex", label: "child-patient-assessment.sucking-reflex" },
          { name: "neuromuscular.rootingReflex", label: "child-patient-assessment.rooting-reflex" },
          { name: "neuromuscular.graspReflex", label: "child-patient-assessment.grasp-reflex" },
        ].map((reflex) => (
          <Grid key={reflex.name} md={2} xs={6}>
            <ByzTitleAndInputBox marginLeft="0px" title={t(reflex.label)}>
              <Controller
                name={reflex.name}
                control={control}
                render={({ field }) => (
                  <ByzMuiRadioButton
                    {...field}
                    typographyText="exists,not-exists"
                    layout="row"
                    border="none"
                    fontSize={16}
                  />
                )}
              />
            </ByzTitleAndInputBox>
          </Grid>
        ))}

        <Grid md={2} xs={6}>
          <ByzTitleAndInputBox marginLeft="0px" title={t("child-patient-assessment.crying")}>
            <Controller
              name="neuromuscular.crying"
              control={control}
              render={({ field }) => (
                <ByzMuiSelect
                  {...field}
                  options={[]}
                  label={t("open-process-menu.select", "capitalize")}
                  sx={{ pt: 1 }}
                />
              )}
            />
          </ByzTitleAndInputBox>
        </Grid>

        <Grid md={2} xs={6}>
          <ByzTitleAndInputBox marginLeft="0px" title={t("child-patient-assessment.general-condition")}>
            <Controller
              name="neuromuscular.generalCondition"
              control={control}
              render={({ field }) => (
                <ByzMuiRadioButton
                  {...field}
                  typographyText="child-patient-assessment.general-condition-active,child-patient-assessment.general-condition-sleepy,unknown"
                  layout="row"
                  border="none"
                  fontSize={16}
                />
              )}
            />
          </ByzTitleAndInputBox>
        </Grid>
      </Grid>
    </Box>
  );
};
